export default __webpack_public_path__ + "static/media/vuesax-linear-task-square2.83243bca.svg";